/** Canonical production origin (www — Vercel redirects apex here). */
export const SITE_ORIGIN = "https://www.bollyrhythm.com";

export function absoluteUrl(path: string): string {
  if (path.startsWith("http")) return path;
  return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
